import React from "react";
import { useHistory } from 'react-router-dom';
import { finalizeOnboarding } from "../../util/commonFunctions";

const CompanyReco = (props) => {
    let history = useHistory();

    const redirectToFollowManagement = () =>{
        finalizeOnboarding(localStorage.getItem("token"));
        props.questionPopupClosedHandler();
        history.push('/follow-management');
    }

    const handleSkipForNow = () => {
        finalizeOnboarding(localStorage.getItem("token"));
        props.questionPopupClosedHandler();
    }

    return (
        <>
            <div className={props.show ? "popup_register_block" : "hide"}>
                <div className="onboarding-topics-list onboarding-companies">
                    <div className="center-text">
                        <strong>Watch companies and stay informed</strong>
                        <span>Add companies to your watchlist to track important updates</span>
                    </div>
                </div>
            </div>
            <div className={props.show ? "question_modal_footer skipbtn" : "hide"}>
                <button className="registration_button" onClick={handleSkipForNow}>
                    Skip for now
                </button>
            </div>
            <div className={props.show ? "question_modal_footer mar-top10" : "hide"}>
                <button className="registration_button" onClick={redirectToFollowManagement}>
                    Add companies
                </button>
            </div>
        </>
    );
};

export default CompanyReco;
